export const MODIFY_FULL_PRICING_INFO = 'MODIFY_FULL_PRICING_INFO';

export function modifyFullPricingInfo(fullPricingInfo){
    return{
        type: MODIFY_FULL_PRICING_INFO,
        mainState: {
            fullPricingInfo: fullPricingInfo
        }
    }
}